import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Proteccion_especiales } from 'src/app/models/protecciones-especiales.model';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-protecciones-especiales',
  templateUrl: './protecciones-especiales.component.html',
  styleUrls: ['./protecciones-especiales.component.css']
})
export class ProteccionesEspecialesComponent {
  public rows = [];
  public actualRow;
  public protecciones_esp: Proteccion_especiales;
  public form;
  public num;
  public formulario;
  public form252 = false;
  public form253 = false;
  public form131 = false;

  public matcher = new FormService();

  constructor() {
    this.formulario = localStorage.getItem("form")


    if (this.formulario == "1-1.1") {
      this.num = '6.4';
    }
    if (this.formulario == "2-5.2") {
      this.form252 = true;
    }
    if (this.formulario == "2-5.3") {
      this.form253 = true;
    }
    if (this.formulario == "1-3.1") {
      this.form131 = true;
    }


    this.form = new FormGroup({
      prot_NO: new FormControl(''),
      prot_ZCH: new FormControl(''),
      prot_ICH: new FormControl(''),
      prot_ZOIT: new FormControl(''),
      prot_ZT: new FormControl(''),
      prot_MH: new FormControl(''),
      prot_Monumento: new FormControl(''),
      prot_Santuatio: new FormControl(''),
      prot_SI: new FormControl(''),
      prot_OTRO: new FormControl(''),
      
      prot_oficial_esp: new FormControl(''),
      obs_modificacion: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("protecciones_esp"))) {
      localStorage.setItem("protecciones_esp", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("protecciones_esp"));
      this.form.controls['prot_NO'].setValue(this.rows[0] ? this.rows[0].prot_NO : '')
      this.form.controls['prot_ZCH'].setValue(this.rows[0] ? this.rows[0].prot_ZCH : '')
      this.form.controls['prot_ICH'].setValue(this.rows[0] ? this.rows[0].prot_ICH : '')
      this.form.controls['prot_ZOIT'].setValue(this.rows[0] ? this.rows[0].prot_ZOIT : '')
      this.form.controls['prot_ZT'].setValue(this.rows[0] ? this.rows[0].prot_ZT : '')
      this.form.controls['prot_MH'].setValue(this.rows[0] ? this.rows[0].prot_MH : '')
      this.form.controls['prot_Monumento'].setValue(this.rows[0] ? this.rows[0].prot_Monumento : '')
      this.form.controls['prot_Santuatio'].setValue(this.rows[0] ? this.rows[0].prot_Santuatio : '')
      this.form.controls['prot_SI'].setValue(this.rows[0] ? this.rows[0].prot_SI : '')
      this.form.controls['prot_OTRO'].setValue(this.rows[0] ? this.rows[0].prot_OTRO : '')
      this.form.controls['prot_oficial_esp'].setValue(this.rows[0] ? this.rows[0].prot_oficial_esp : '')
      this.form.controls['obs_modificacion'].setValue(this.rows[0] ? this.rows[0].obs_modificacion : '')

    }

  }

  add_protecciones_esp() {
    localStorage.setItem("protecciones_esp", JSON.stringify([]));
    this.actualRow = localStorage.getItem("protecciones_esp");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      prot_NO: this.form.value.prot_NO,
      prot_ZCH: this.form.value.prot_ZCH,
      prot_ICH: this.form.value.prot_ICH,
      prot_ZOIT: this.form.value.prot_ZOIT,
      prot_ZT: this.form.value.prot_ZT,
      prot_MH: this.form.value.prot_MH,
      prot_Monumento: this.form.value.prot_Monumento,
      prot_Santuatio: this.form.value.prot_Santuatio,
      prot_SI: this.form.value.prot_SI,
      prot_OTRO: this.form.value.prot_OTRO,

      prot_oficial_esp: this.form.value.prot_oficial_esp,
      obs_modificacion: this.form.value.obs_modificacion

    })
    localStorage.setItem("protecciones_esp", JSON.stringify(this.rows));
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("protecciones_esp", JSON.stringify(this.rows));
      }
    }
  }

}
